/* eslint-disable */
import { Grid, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import * as context from 'api/base';
import { Link } from 'react-router-dom';
import { getNewBuyInsurancePathGeneric } from '../../routes/generic/Helpers/HomePageHelper';
import { productDetailsCardStyles } from '../styles/widgetStyles';
import { useSelector } from 'react-redux';

function ProductDetailedCardWidget(props) {
	let themeinfo = context.getSettings();
	const theme = useTheme();
	const classes = productDetailsCardStyles(theme, themeinfo);
	let productInfo = context.getProducts(props.productInstanceId);
	const channelProducts = useSelector(({ fuse }) => fuse.form.channelProducts);
	const referenceTokenDetails = useSelector(({ fuse }) => fuse.form.referenceTokenDetails);
	const myHostPrefix = useSelector(({ fuse }) => fuse.form.mySite.hostPrefix);

	const prodItems = [];
	productInfo.forEach(pitem =>
		prodItems.push(
			<Grid
				item
				key={pitem.instanceId}
				className={clsx(
					'w-full h-100 text-left p-12',
					props.columnType === 'ONE' ? 'sm:w-full self-center' : 'sm:w-1/2'
				)}
				xs={12}
				md={6}
				lg={props?.columns || 4}
				xl={props?.columns || 4}
			>
				<Card className={clsx('rounded-10')} sx={classes.card}>
					<div className={clsx('px-24 py-16')} style={classes.cardHeader}>
						<Typography variant="h4" className="font-bold mr-10">
							<Icon fontSize="inherit" className="float-left text-40 arrow-icon -mt-4 pt-3.5">
								{pitem.icon}
							</Icon>
							{pitem.contents['PRODUCT-NAME']}
						</Typography>
					</div>

					<CardContent className="p-32">
						<div className="flex flex-col">
							<div
								dangerouslySetInnerHTML={{
									__html: pitem.contents[`PRODUCT-${props?.descriptionType}`]
								}}
							/>
							<br />
							<Link to={`/fast-facts-products/${pitem.instanceId}`}>
								<strong>[Fast Facts Comparison]</strong>
							</Link>
						</div>
					</CardContent>

					<div className="flex justify-center pb-32">
						<Button
							sx={classes.cardButton}
							component={Link}
							to={getNewBuyInsurancePathGeneric(
								channelProducts,
								referenceTokenDetails?.token,
								myHostPrefix
							)}
							variant="contained"
							color="primary"
							data-ga-label={`product-detailed-card-get-cover-now-${pitem?.instanceId?.split('-')?.pop()}`}
						>
							Get Cover Now
						</Button>
					</div>
				</Card>
			</Grid>
		)
	);

	return (
		<div className="w-full my-32">
			<Grid
				container
				justifyContent="center"
				alignItems="stretch"
				flexDirection={props.columnType === 'ONE' ? 'column' : 'row'}
			>
				{prodItems}
			</Grid>
		</div>
	);
}

export default ProductDetailedCardWidget;
